import React from "react";
import styles from './HelpText.module.scss';

export const HelpText = ({children, disabled = false}) => {
    return (
        <p className={`help-text ${styles.helpText}`} disabled={disabled}>
            {children}
        </p>
    );
}
